import * as ActionTypes from './ActionTypes'

import { Map } from 'immutable'

const getInitialState = () => {
  return Map({
    orderNumberMin: undefined,
    orderNumberMax: undefined,
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNINVOICE_MANAGER_SET_ORDER_NUMBER_MIN:
      return state.set('orderNumberMin', action.orderNumberMin)

    case ActionTypes.VNINVOICE_MANAGER_SET_ORDER_NUMBER_MAX:
      return state.set('orderNumberMax', action.orderNumberMax)

    default:
      return state
  }
}

export default reducer
